/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

export function heroLoadAnimation() {

  // Set Padding
  if (window.innerWidth > 960) {
    var heroHeight = $('.homeHero__title').height();
    var windowHeight = $(window).height();
    var centeredPadding = (windowHeight - heroHeight) / 2;
    $('.homeHero').css('paddingTop', centeredPadding + 'px');
  }

  const title = document.querySelector(".homeHero__title");

  function heroSplitText() {

    // Reset if needed
    if (title.anim) {
      title.anim.progress(1).kill();
      title.split.revert();
    }

    title.split = new SplitText(title, {
      type: "lines,words",
      linesClass: "split-line",
      wordsClass: "split-word"
    });

    // Set up the anim
    title.anim = gsap.from(title.split.words, {
      scrollTrigger: {
        trigger: title,
        toggleActions: "restart pause resume reverse",
        start: "top 60%",
        once: true
      },
      duration: 0.5,
      ease: "circ.out",
      y: 110,
      // rotate: 2.5,
      stagger: 0.05,
      delay: 0.3,
    });

  }

  function splitLoaded() {
    setTimeout(() => {
      $('.homeHero__title').addClass('split-loaded');
    }, 850);
  }

  function heroLoaded() {
    $('.homeHero').addClass('loaded');
  }

  // Desktop Animation
  if (window.innerWidth > 960) {

    // Animate In
    let tl = gsap.timeline();
    tl.to('.homeHero__title', {
      opacity: '1',
      duration: 0,
      delay: 0.25
    })
      .add(heroSplitText)
      .call(splitLoaded)
      .to('.homeHero', {
        paddingTop: '162px',
        duration: 0.25,
        delay: 1.8,
        ease: "power3.out"
      })
      .call(heroLoaded)
      .add(function () { $('.section').css('opacity', '1') })
      .to('.homeHero__tagline', {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out"
      }, "-=0.15")
      .to('.homeHero__cta', {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out"
      }, "-=0.45")
      .to('.homeHero__tableWrap', {
        y: '0',
        duration: 1,
        ease: "power3.out"
      }, "-=0.95")
      .to('.siteHeader', {
        y: 0,
        duration: 0.35,
      }, "-=1");

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 3000);

    // Artificial parallax to have the table slide up a bit as you scroll
    gsap.to('.homeHero__table', {
      scrollTrigger: {
        trigger: ".homeHero",
        scrub: 1,
        start: 'top 0-=10px',
        end: 'bottom 50%',
        // markers: true,
      },
      y: '50px',
    });
  }

  // Mobile Animation
  else {
    //
  }


}

export function heroLoadAnimationSimpler() {

  // Set Padding
  const title = document.querySelector(".homeHero__title");

  function heroSplitText() {

    // Reset if needed
    if (title.anim) {
      title.anim.progress(1).kill();
      title.split.revert();
    }

    title.split = new SplitText(title, {
      type: "lines,words",
      linesClass: "split-line",
      wordsClass: "split-word"
    });

    // Set up the anim
    title.anim = gsap.from(title.split.words, {
      scrollTrigger: {
        trigger: title,
        toggleActions: "restart pause resume reverse",
        start: "top 60%",
        once: true
      },
      duration: 0.5,
      ease: "circ.out",
      y: 110,
      // rotate: 2.5,
      stagger: 0.05,
    });

  }

  function splitLoaded() {
    setTimeout(() => {
      $('.homeHero__title').addClass('split-loaded');
    }, 850);
  }

  function heroLoaded() {
    $('.homeHero').addClass('loaded');
  }

  // Desktop Animation
  if (window.innerWidth > 960) {

    // Animate In
    let tl = gsap.timeline();
    tl.to('.homeHero__title', {
      opacity: '1',
      duration: 0
    })
      .add(heroSplitText)
      .call(splitLoaded)
      .call(heroLoaded)
      .add(function () { $('.section').css('opacity', '1') })
      .to('.homeHero__tagline', {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out",
        delay: 0.1
      })
      .to('.homeHero__cta', {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out",
        delay: 0.1
      })
      .to('.siteHeader', {
        y: 0,
        duration: 0.35,
      }, "-=0.5");

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 3000);

  }

  // Mobile Animation
  else {
    //
  }


}
